<template>
  <div :class="classes()" v-bind="attributes">
    <Picture
      v-if="brush"
      :class="`${el}__picture ${el}__brush`"
      :img="brushImage"
      responsive
      :noLazy="noLazy"
    />
    <Picture
      v-if="name"
      :class="`${el}__picture`"
      :img="illustrationImage"
      responsive
      :noLazy="noLazy"
    />
  </div>
</template>

<script>
import Picture from '@/objects/Picture';

const IllustrationTypes = [
  'teaser-1',
  'teaser-2',
  'teaser-3',
  'teaser-4',
  'teaser-5',
  'teaser-6',
  'teaser-7',
  'teaser-8',
  'teaser-9',
  'teaser-10',
  'title-1',
  'title-2',
  'title-3',
  'title-4',
  'title-5',
];

const IllustrationBrushColorTypes = ['secondaryYellow', 'primaryBlue', 'primaryCoral'];

export default {
  name: 'Illustration',
  components: { Picture },
  props: {
    name: {
      type: String,
      validator: (val) => IllustrationTypes.includes(val),
    },
    brushColor: {
      type: String,
      default: 'primaryBlue',
      validator: (val) => IllustrationBrushColorTypes.includes(val),
    },
    brush: {
      type: Number,
      validator: (val) => [1, 2, 3, 4, 5, 6].includes(val),
    },
    brushScale: {
      type: [String, Number],
      default: 1,
    },
    illuScale: {
      type: [String, Number],
      default: 1,
    },
    opacity: {
      type: [String, Number],
      default: 1,
    },
    noLazy: Boolean,
  },
  computed: {
    illustrationImage() {
      return `${this.path}/illus/${this.name}`;
    },

    brushImage() {
      return `${this.path}/brushes/${this.brushColor}/${this.brush}`;
    },

    attributes() {
      let variables = '';

      if (this.brush) {
        variables += `--brushScale: ${this.brushScale};`;
      }

      if (this.name) {
        variables += `--illuScale: ${this.illuScale}; --opacity: ${this.opacity}`;
      }

      return {
        style: variables,
      };
    },
  },
  data() {
    return {
      path: '/assets/illustrations',
      el: 'o-illustration',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--backgroundBrush`]: !!this.brush && !!this.name,
        };
      },
    };
  },
};
</script>
